import { useEffect, useState } from "react";
import PortalLayout from "@/layouts/PortalLayout";
import { api } from "@/lib/api";
import { Folder, Download, Image, FileText } from "lucide-react";
import { useLang } from "@/context/LangContext";
import ResourceGallery from "@/components/ResourceGallery";
import { absUrl } from "@/components/MultiImageUpload";

export default function PressResources() {
  const { t } = useLang();
  const [rs, setRs] = useState([]);
  useEffect(() => { api.get("/press/resources").then((r) => setRs(r.data)).catch(() => {}); }, []);

  const iconFor = (t) => t === "press_kit" ? Image : t === "report" ? FileText : Folder;

  return (
    <PortalLayout sidebar="press">
      <h1 className="text-3xl font-bold text-navy md:text-4xl">{t("press_pressresources_01")}</h1>
      <p className="mt-1 text-neutral-600">{t("press_pressresources_02")}</p>
      <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {rs.map((r) => {
          const I = iconFor(r.type);
          return (
            <div key={r.id} className="rounded-2xl border border-neutral-100 bg-white p-5" data-testid={`press-resource-${r.id}`}>
              <div className="grid h-10 w-10 place-items-center rounded-xl bg-wine-50 text-wine-600"><I className="h-5 w-5" /></div>
              <h3 className="mt-3 font-serif text-base font-semibold text-neutral-900">{r.title}</h3>
              <p className="mt-1 text-xs text-neutral-500">{r.category}{r.size_kb ? ` · ${Math.round(r.size_kb / 100) / 10} MB` : ""}</p>
              <p className="mt-2 line-clamp-2 text-sm text-neutral-600">{r.description}</p>
              {(r.url || r.pdf_url) && <a href={absUrl(r.url || r.pdf_url)} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-xs font-semibold text-wine-600 hover:text-wine-700" data-testid={`press-dl-${r.id}`}>
                <Download className="h-3.5 w-3.5" />{t("press_pressresources_03")}</a>}
              <ResourceGallery resource={r} />
            </div>
          );
        })}
      </div>
    </PortalLayout>
  );
}
